<template>
  <div 
    class="jyf-parser" 
    :id="'rtf' + uid"
    :style="selectable ? 'user-select: text; -webkit-user-select: text;' : ''"
    v-html="processedHtml"
  ></div>
</template>

<script>
export default {
  name: 'jyf-parser',
  props: {
    html: {
      type: String,
      default: ''
    },
    selectable: {
      type: Boolean,
      default: false
    },
    domain: {
      type: String,
      default: ''
    },
    lazyLoad: {
      type: Boolean,
      default: false
    },
    loadingImg: {
      type: String,
      default: ''
    },
    autoscroll: {
      type: Boolean,
      default: false
    },
    autosetTitle: {
      type: Boolean,
      default: true
    },
    tagStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      uid: this._uid,
      processedHtml: ''
    }
  },
  watch: {
    html: {
      immediate: true,
      handler(html) {
        this.processHtml(html)
      }
    }
  },
  mounted() {
    if (this.html) {
      this.processHtml(this.html)
    }
    this.$nextTick(() => {
      this.initContent()
    })
  },
  methods: {
    processHtml(html) {
      if (!html) {
        this.processedHtml = ''
        return
      }
      
      // 创建临时 div 来处理 HTML
      const div = document.createElement('div')
      div.innerHTML = html
      
      // 处理样式
      let style = '<style>img{max-width:100%}'
      for (const tag in this.tagStyle) {
        style += `${tag}{${this.tagStyle[tag]}}`
      }
      style += '</style>'
      
      // 处理 domain
      if (this.domain) {
        const imgs = div.getElementsByTagName('img')
        for (let img of imgs) {
          let src = img.getAttribute('src')
          if (src && !src.includes('://') && src.indexOf('data:') !== 0) {
            if (src[0] === '/') {
              img.src = this.domain + src
            } else {
              img.src = this.domain + '/' + src
            }
          }
        }
        
        const videos = div.getElementsByTagName('video')
        for (let video of videos) {
          let src = video.getAttribute('src')
          if (src && !src.includes('://') && src.indexOf('data:') !== 0) {
            if (src[0] === '/') {
              video.src = this.domain + src
            } else {
              video.src = this.domain + '/' + src
            }
          }
        }
      }
      
      // 处理标题
      const titles = div.getElementsByTagName('title')
      if (titles.length && this.autosetTitle) {
        document.title = titles[0].innerText
      }
      
      // 处理表格滚动
      if (this.autoscroll) {
        const tables = div.getElementsByTagName('table')
        for (let table of tables) {
          const wrapper = document.createElement('div')
          wrapper.style.overflow = 'scroll'
          wrapper.style.width = '100%'
          table.parentNode.replaceChild(wrapper, table)
          wrapper.appendChild(table)
        }
      }
      
      this.processedHtml = style + div.innerHTML
    },
    initContent() {
      const container = document.getElementById('rtf' + this.uid)
      if (!container) return
      
      // 处理图片点击
      const imgs = container.getElementsByTagName('img')
      const imgList = []
      for (let i = 0; i < imgs.length; i++) {
        const img = imgs[i]
        imgList.push(img.src)
        img.onclick = (e) => {
          e.stopPropagation()
          this.$emit('imgtap', {
            src: img.src,
            i: i
          })
        }
        img.onerror = () => {
          if (this.loadingImg) {
            img.src = this.loadingImg
          }
          this.$emit('error', {
            source: 'img',
            target: img
          })
        }
      }
      
      // 处理链接点击
      const links = container.getElementsByTagName('a')
      for (let link of links) {
        link.onclick = (e) => {
          e.stopPropagation()
          const href = link.getAttribute('href')
          this.$emit('linkpress', { href })
          if (href && (href.indexOf('http') === 0 || href.indexOf('//') === 0)) {
            return true
          }
          return false
        }
      }
      
      // 处理视频
      const videos = container.getElementsByTagName('video')
      for (let video of videos) {
        video.style.maxWidth = '100%'
        video.onerror = () => {
          this.$emit('error', {
            source: 'video',
            target: video
          })
        }
      }
      
      this.$emit('load')
      this.$emit('parse', container)
    }
  }
}
</script>

<style scoped>
.jyf-parser {
  word-wrap: break-word;
  word-break: break-all;
}

.jyf-parser >>> img {
  max-width: 100%;
  height: auto;
}

.jyf-parser >>> video {
  max-width: 100%;
  height: auto;
}

.jyf-parser >>> table {
  width: 100%;
  border-collapse: collapse;
}
</style>
